module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-system-bar', [_c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/invoices'
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("chevron_left")]), _vm._v("\n      Return to invoices\n    ")], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "extended": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "loading": _vm.requests.get.loading
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "mr-3"
  }, [_vm._v("Payments")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "color": "info"
    },
    on: {
      "click": _vm.launchDateRangePicker
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("event")]), _vm._v("\n    " + _vm._s(_vm.globalActiveDateRangeFormatted) + "\n    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Search",
      "type": "Search",
      "hint": "Search on reference, or amount",
      "append-icon": "search"
    },
    on: {
      "click:append": _vm.doSearch,
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doSearch.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.clearSearch.apply(null, arguments)
      }]
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-3 ml-2 mr-0",
    attrs: {
      "label": "within date range"
    },
    model: {
      value: (_vm.searchwithdaterange),
      callback: function($$v) {
        _vm.searchwithdaterange = $$v
      },
      expression: "searchwithdaterange"
    }
  }), _vm._v(" "), _c('template', {
    slot: "extension"
  }, [_vm._v("\n      " + _vm._s(_vm.numTransactions) + " payments found\n      "), (_vm.activesearch) ? _c('v-chip', {
    staticClass: "v-chip--x-small ml-2",
    attrs: {
      "close": ""
    },
    on: {
      "input": _vm.clearSearch
    }
  }, [_vm._v(_vm._s(_vm.activesearch))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.numPages && _vm.numPages > 0) ? [_c('v-btn', {
    attrs: {
      "disabled": _vm.page <= 1,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.page--
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v("\n        Page " + _vm._s(_vm.page) + " of " + _vm._s(_vm.numPages) + "\n        "), _c('v-btn', {
    attrs: {
      "disabled": _vm.page >= _vm.numPages,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.page++
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)] : _vm._e()], 2)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.requests.get,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-list', [_vm._l((_vm.transactions), function(payment) {
    return [_c('payment-list-item', {
      key: payment.id,
      attrs: {
        "item": payment
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (payment.id))
    })]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.page <= 1,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.page--
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.page >= _vm.numPages,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.page++
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40a9d0ee","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/layout/Transactions.vue
// module id = 1400
// module chunks = 9